import { useEffect } from 'react';
import { useLoadingStore } from '../../stores/loadingStore';

/**
 * Suspense fallback for lazy-loaded pages.
 *
 * It renders NOTHING — instead of swapping the page out for big gray skeleton
 * boxes, we keep whatever is already on screen and signal the global loading
 * store. That drives the thin {@link TopLoadingBar} under the header, which is
 * the non-intrusive, production-standard way to show route/chunk loading.
 *
 * On a first paint (nothing rendered yet) this just means a blank content area
 * for the brief moment a chunk loads — the top bar still communicates progress.
 */
export function PageLoader() {
  const begin = useLoadingStore((s) => s.begin);
  const end = useLoadingStore((s) => s.end);

  useEffect(() => {
    begin();
    return end;
  }, [begin, end]);

  return null;
}
